import Constants from '@/Constants';
import { Attachment } from '@/models/Attachment';
import { ApplicationState } from '@/store';
import { putAttachmentRequest } from '@/store/attachments/action';
import { AttachmentRequest } from '@/store/attachments/types';
import React, { SyntheticEvent, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

interface Props {
    attachment: Attachment;
}

const RenameDropDown: React.FC<Props> = (props: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const dispatch = useDispatch();

    const { attachment } = props;

    const [newAttachmentName, setNewAttachmentName] = useState<string>(attachment.name);
    const [canRenameAttachment, setCanRenameAttachment] = useState<boolean>(false);
    const [dropDownVisible, setDropDownVisible] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const toggleModal = () => {
        setDropDownVisible(!dropDownVisible);
    };

    const handleOnChange = useCallback((value: string) => {
        setNewAttachmentName(value.trim());
    }, []);

    const handleSaveClick = (e: SyntheticEvent) => {
        e.preventDefault();

        const attachmentRequestData = {
            id: attachment.id,
            locale: attachment.locale,
            name: newAttachmentName,
        } as AttachmentRequest;

        dispatch(putAttachmentRequest(attachmentRequestData));

        setCanRenameAttachment(false);
        setDropDownVisible(false);
    };

    const handleCancelClick = (e: SyntheticEvent) => {
        e.preventDefault();

        if (inputRef.current) {
            inputRef.current.value = attachment.name;
            setNewAttachmentName(attachment.name);
        }
        setDropDownVisible(false);
    };

    useEffect(() => {
        setCanRenameAttachment(newAttachmentName !== '' && attachment.name !== newAttachmentName);
    }, [newAttachmentName]);

    return (
        <>
            <div className="dropdown-container">
                <div className="dropdown">
                    <button className="btn btn-link btn-rename" onClick={toggleModal} type="button">
                        {strings.RENAME}
                    </button>

                    <div className={dropDownVisible ? 'dropdown-menu dropdown-menu-right show' : 'dropdown-menu dropdown-menu-right'}>
                        <div className="triangle-container">
                            <div className="dropdown-triangle" />
                            <div className="dropdown-triangle-border" />
                        </div>
                        <div className="dropdown-content">
                            <h1>{strings.RENAME_ATTACHMENT}</h1>
                            <div className="dropdown-form">
                                <input
                                    className="form-control"
                                    defaultValue={attachment.name}
                                    maxLength={86}
                                    onChange={(e) => handleOnChange(e.target.value)}
                                    placeholder={strings.NEW_ATTACHMENT_NAME}
                                    ref={inputRef}
                                    type="text"
                                />

                                <div className="btn-container">
                                    <div className="btn-container__cancel">
                                        <a href="#" onClick={handleCancelClick}>
                                            <span className="cancel-btn">{strings.CANCEL}</span>
                                        </a>
                                    </div>

                                    <div className="btn-container__save">
                                        <button className="btn save-btn" disabled={!canRenameAttachment} onClick={handleSaveClick}>
                                            <span className="save-btn">{strings.SAVE}</span>
                                            <i className="material-icons-outlined icon save-icon">{Constants.icons.SAVE}</i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RenameDropDown;
